import { Button } from '@repo/shadcn';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';

import { PaymentStatusBadge } from '@components/ui/badge';

import { Route } from '@/constants';
import { PurchaseListItemType } from '@/features/slice/purchases/purchase.schema.ts';
import { DateFormatter, formatCurrencyInBDT } from '@/utils';

import { DataTableHeader } from '../../../components/ui/data.table';

export const purchaseTableColumns: ColumnDef<PurchaseListItemType>[] = [
    {
        accessorKey: 'invoice_number',
        header: () => {
            return (
                <DataTableHeader sortByColumnName="invoice_number" align="left">
                    Invoice Number
                </DataTableHeader>
            );
        },
        cell: ({ row }) => (
            <div className="font-medium">
                <Link
                    to={`${Route.PURCHASES}/${row.original.id}`}
                    className="cursor-pointer transition-all duration-150 hover:underline"
                >
                    {row.original.invoice_number}
                </Link>
            </div>
        ),
    },

    {
        accessorKey: 'supplier_id',
        header: () => <div>Supplier Name</div>,
        cell: ({ row }) => {
            return (
                <div className="font-medium">
                    <Link
                        to={`${Route.SUPPLIERS}/${row.original.supplier_id}`}
                        className="cursor-pointer transition-all duration-150 hover:underline"
                    >
                        {row.original.supplier_name}
                    </Link>
                </div>
            );
        },
    },

    {
        accessorKey: 'date',
        header: () => <div>Date</div>,
        cell: ({ row }) => (
            <div className="font-medium">
                {DateFormatter.formatDate(row.original.created_at)}
            </div>
        ),
    },

    {
        accessorKey: 'payment_status',
        header: () => <div>Status</div>,
        cell: ({ row }) => (
            <div className="">
                <PaymentStatusBadge
                    status={row.original.payment_status ?? undefined}
                />
            </div>
        ),
    },

    {
        accessorKey: 'total_price',
        header: () => <div className="text-right">Total Price</div>,
        cell: ({ row }) => (
            <div className="text-right">
                {formatCurrencyInBDT(row.original.total_price || 0)}
            </div>
        ),
    },

    {
        accessorKey: 'paid_amount',
        header: () => <div className="text-right">Total Paid</div>,
        cell: ({ row }) => (
            <div className="text-right">
                {formatCurrencyInBDT(row.original?.paid_amount || 0)}
            </div>
        ),
    },

    {
        accessorKey: 'action',
        header: () => <div className="text-right">Action</div>,
        cell: ({ row }) => (
            <div className="flex justify-end">
                <Link to={`${Route.PURCHASES}/${row.original.id}`}>
                    <Button type="button" size="sm" variant="outline">
                        View Details
                    </Button>
                </Link>
            </div>
        ),
    },
];
